import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FacebookService, InitParams, UIParams, UIResponse } from 'ngx-facebook';
import { DESCIPTION_BASE } from '../../constant/app-constant';
import { CanonicalService } from '../../service/canonical/canonical.service';
import { HomeService } from '../../service/home/home.service';
import { MetaTagsService } from '../../service/meta-tag/meta-tags.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FRONT_URL } from '../../constant/app-constant';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

declare var adsbygoogle: any[];

@Component({
  selector: 'snack-bar',
  templateUrl: './snack-bar.html',
  styles: [
    `
    .example-pizza-party {
      color: hotpink;

    }
  `,
  ],
})
export class PizzaPartyComponent { }
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  url: any
  yt = false
  value = ""
  newsPostTitle: any;
  totalImg = new Array();
  minArrImg = new Array();
  postImage = new Array();
  twitterPost = new Array();
  featuredsNews = new Array();
  youtubePost: any
  durationInSeconds = 3;
  constructor(private homeService: HomeService, private router: Router, private http: HttpClient,
    private title: Title, private meta: Meta, private metaService: MetaTagsService,
    private canonicalService: CanonicalService, private fb: FacebookService, private _snackBar: MatSnackBar,
    private sanitizer: DomSanitizer, @Inject(DOCUMENT) private document: Document, @Inject(PLATFORM_ID) private platformId: Object) {

    let post_name = this.router.url.split('/')[4]

    if (this.router.url.split('/')[1] === 'sinhala') {
      post_name = this.router.url.split('/')[5]
    }

    post_name = post_name.split("?")[0]

    var mySubString = this.router.url.substring(
      this.router.url.indexOf("/") + 1,
      this.router.url.lastIndexOf("/")
    );
    let date = mySubString.split('/').join('-')
    if (mySubString.split('/')[0] === 'sinhala')
      date = mySubString.split('/')[1] + '-' + mySubString.split('/')[2] + '-' + mySubString.split('/')[3]


    this.getPostByPostName(post_name, date)
    this.getFeaturedNews()

  }
  newsPost: any;
  post: any
  test: any
  otherNews = new Array();
  notfound = false;
  content: any
  browser: any
  ngOnInit() {
    this.browser = isPlatformBrowser(this.platformId);

    // const postId = localStorage.getItem('id')
    this.canonicalService.destroyLinkForCanonicalURL()

    this.canonicalService.setCanonicalURL();

    // this.metaService.destroyTags()
    const x = FRONT_URL + this.router.url

    this.value = x
    // this.test='<p><span style="font-size:14px"><span style="font-family:Georgia,serif">COLOMBO (News 1st) - Generator 3 at the Norochcholai Coal Power Plant has failed.</span></span></p><p><span style="font-size:14px"><span style="font-family:Georgia,serif">The Chairman of the Public Utilities Commission of Sri Lanka said that the Generator failed due to a fault.</span></span></p><p><span style="font-size:14px"><span style="font-family:Georgia,serif">He warned that lengthy power cuts are expected in the future, and the power cut schedule will be announced soon.</span></span></p><p><span style="font-size:14px"><span style="font-family:Georgia,serif">Generator 2 at the Norochcholai Coal Power Plan is already out of for repairs.</span></span></p><p><span style="font-size:14px"><span style="font-family:Georgia,serif">Accordingly, only 300 MW of a total of 900 MW is being generated.</span></span><br />&nbsp;</p> <p>Also Watch:&nbsp;</p><div data-oembed-url="https://www.youtube.com/watch?v=93vDu5QWfvc"><div><div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 56.25%;"><iframe allow="accelerometer *; clipboard-write *; encrypted-media *; gyroscope *; picture-in-picture *;" allowfullscreen="" scrolling="no" src="//if-cdn.com/vWQlNgZ" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;" tabindex="-1"></iframe></div></div></div><p>&nbsp;</p>'
    for (let index = 0; index < 10; index++) {
      try {
        (adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        // console.error("error");;
      }

    }
    try {
      let initParams: InitParams = {
        appId: '1779003665736132',
        xfbml: true,
        version: 'v2.10'
      };
      if (this.browser) {
        this.fb.init(initParams);
      }
    } catch (e) {
      console.log(e);

    }

  }

  // ngAfterViewInit() {
  //   if (this.browser) {
  //     for (let index = 0; index < 10; index++) {
  //       try {
  //         (adsbygoogle = window.adsbygoogle || []).push({});
  //       } catch (e) {
  //         console.error("error");
  //       }

  //     }

  //   }
  // }

  copyUrl() {
    this._snackBar.openFromComponent(PizzaPartyComponent, {
      duration: this.durationInSeconds * 1000,
    });
  }
  author: string = ""
  post_date: string = ""
  getPostByPostName(post_name: string, date: string) {
    this.homeService.getPostByPostName(post_name, date).subscribe((resp: any) => {

      this.author = "by " + resp.author

      this.post_date = resp.date.split("T")[0] + ' | ' + resp.date.split("T")[1].split(".")[0] + ''

      const desc = resp.excerpt.rendered.replace(/(<([^>]+)>)/ig, '').substring(0, 150) + ' - ' + DESCIPTION_BASE
      this.title.setTitle(resp.title.rendered)


      this.metaService.setMetaTags(resp.tags)
      this.metaService.setOgTags(resp.title.rendered, desc, resp.images.large_tile_image, '/' + resp.post_url);
      this.meta.updateTag(
        { name: 'keywords', content: resp.tags }
      )
      this.meta.updateTag(
        { name: 'description', content: desc }
      );
      this.newsPost = resp
      this.newsPostTitle = resp
      this.content = this.sanitizer.bypassSecurityTrustHtml(this.newsPost.content.rendered)

      this.getRelatedNews(resp.category_ID, resp.id)
      this.postImage = this.newsPost?.post_image
      this.twitterPost = this.newsPost?.twitter_post
      // console.log("this.newsPost?.video_post   === ", this.newsPost?.video_post);


      if (this.newsPost?.video_post != null) {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.newsPost?.video_post.video_id + '?autoplay=1')

      }
      if (this.newsPost?.youtube_post != undefined) {
        this.yt = true
        for (const iterator of this.newsPost?.youtube_post) {
          this.youtubePost = this.sanitizer.bypassSecurityTrustResourceUrl(iterator)
        }
      } else {
        this.yt = false
      }
      let x = 0
      if (this.newsPost.gallery_image != null) {

        for (let j = 0; j < this.newsPost.gallery_image.length / this.newsPost.gallery_count; j++) {
          this.minArrImg = []
          for (let i = 0; i < this.newsPost.gallery_count; i++) {

            this.minArrImg.push(this.newsPost.gallery_image[x + i]?.meta_value)
            if (i == 1) {
              x = x + 2
            }
          }
          this.totalImg.push(this.minArrImg)

        }
      }
    }, ((error) => {
      this.getRelatedNews(81, 0)
      console.log("==================  :   ", error.status);
      if (error.status == 500) {
        this.notfound = true;
        this.document.getElementById('testId')!.className = 'new_details_new';
        const img = this.document.getElementById("post_img") as HTMLImageElement;
        img.src = "https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/pagenot-found-banner (3).webp"
        this.document.getElementsByClassName("new_details_new")[0].innerHTML = "The page you have requested was not found. We will redirect you to the homepage in 5 seconds."
        var timeleft = 5;
        var downloadTimer = setInterval(() => {
          if (timeleft <= 0) {
            clearInterval(downloadTimer);
            this.document.getElementById("countdown")!.innerHTML = "Redirecting now....";
            this.document.location.href = FRONT_URL;
          } else {
            this.document.getElementById("countdown")!.innerHTML = "Redirecting : " + timeleft + " seconds.";
          }
          timeleft -= 1;
        }, 1000);
      }
    }))
  }

  getFeaturedNews() {
    this.homeService.getPostByCategory(36569, 5, [0]).subscribe((resp: any) => {
      this.featuredsNews = resp.postResponseDto
    })
  }
  test1 = ""

  shareFB(url: string) {


    let params: UIParams = {
      method: 'share',
      display: 'popup',
      // mobile_iframe: true,
      // href: "http://34.100.175.63:4000/" + url,
      href: "https://sinhala.newsfirst.lk/" + url,


    };


    this.fb.ui(params)
      .then((res: any) => console.log(res))
      .catch((e: any) => console.error(e));
  }



  replaceString(str: string) {
    return str.replace('<h2>', '<h2 style="line-height: initial;">');
  }




  getRelatedNews(cat: number, id: number) {
    this.otherNews = []
    this.homeService.getPostByCategory(cat, 7, [0]).subscribe((resp: any) => {
      for (const i of resp.postResponseDto) {
        if (i.id !== id) {
          this.otherNews.push(i)
        }
      }

    })
  }


  getLatestNews() {
    this.homeService.getAllNews().subscribe((resp: any) => {

      this.otherNews = resp.postResponseDto

    })
  }

}
